import { render, staticRenderFns } from "./SignInProblemStep.vue?vue&type=template&id=28611ab8&lang=pug&"
import script from "./SignInProblemStep.vue?vue&type=script&lang=ts&"
export * from "./SignInProblemStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports